module.exports = __webpack_public_path__ + "static/media/pet-user-date.de783a0f.svg";